module.exports = __webpack_public_path__ + "static/media/65.8a430a37.jpg";